import { combineReducers } from 'redux'
import { createCollectionOrderReducer } from './create-collection-order-reducer'
import { getCollectionOrderStatusReducer } from './get-collection-order-status-reducer'

export const CollectionOrderReducer = combineReducers({
  createCollectionOrder: createCollectionOrderReducer,
  getCollectionOrderStatus: getCollectionOrderStatusReducer,
})
